import React, {useEffect} from "react";
import ReactHtmlParser from 'react-html-parser';
import loadjs from 'loadjs';

export default function EmbedHtmlMarketo(props) {
  const { embedHtml, id } = props;

  const appendScript = (scriptHtml) => {
    const head = document.head;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = ReactHtmlParser(scriptHtml);
    head.appendChild(script);
  }
  
  useEffect(() => {
    
    const execScripts = (scripts) => {
      scripts.forEach(script => appendScript(script.innerHTML));
    }
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(embedHtml, "text/html");
    const scriptTags = doc.querySelectorAll('script');
    const scriptUrls = [];
    const scripts = [];

    scriptTags.forEach((scriptTag) => {
      if (scriptTag.src) {
        scriptUrls.push(scriptTag.src);
      } else {
        scripts.push(scriptTag);
      }
    });
    try{
    if (scriptUrls.length > 0) {
      loadjs(scriptUrls, 'callback', {
        numRetries: 3
      });
      loadjs.ready('callback', {
        success: () => execScripts(scripts)
      });
    } else {
      execScripts(scripts);
    }
  }catch(ex){
    execScripts(scripts);
  }

  }, [embedHtml]);
  
  const parsedHtml = ReactHtmlParser(embedHtml).filter(item => !!item);

  return (
      <div id={id}>
        {parsedHtml}
      </div>
  );
}